import { render, staticRenderFns } from "./IntradayRiskyAccountDetails.vue?vue&type=template&id=43c5290e"
import script from "./IntradayRiskyAccountDetails.vue?vue&type=script&lang=js"
export * from "./IntradayRiskyAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports